<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-start pe-5">
                    <h3 class="fw-bold my-4">Modern Solutions for Manufacturers</h3>
                    <button class="btn-blue mt-5">Free Registration</button>
                </div>
                <div class="col-md-5 text-end">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">Our Solutions for Business Owners</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        In today’s competitive world, manufacturers need to leverage modern technologies to increase productivity, reduce costs, and optimize production processes. Our company utilizes artificial intelligence, the Internet of Things, blockchain, and data analytics to offer advanced solutions tailored for manufacturers. Our services help you streamline production processes, improve product quality, and create sustainable competitive advantages.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-start">
                        <h4 class="fw-bold">Challenges Faced by Manufacturers</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>Increasing Production Costs:</strong> The costs of raw materials, energy, and labor are rising.
                                </li>
                                <li class="mt-3">
                                    <strong>Need for Optimizing Production Processes:</strong> Manufacturers need to reduce resource waste and improve production line performance.
                                </li>
                                <li class="mt-3">
                                    <strong>Management of Production Data and Machinery Performance:</strong> Many manufacturing units are unable to accurately collect and analyze production data.
                                </li>
                                <li class="mt-3">
                                    <strong>Quality and Production Standards:</strong> Adhering to quality standards is essential to maintain competitiveness.
                                </li>
                                <li class="mt-3">
                                    <strong>Supply Chain and Supplier Management:</strong> Manufacturers face challenges in managing raw material supply and supplier interactions.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">Our Services for Manufacturers</h3>
                <h6>We offer comprehensive and innovative solutions for manufacturers, including the following:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Optimizing Production Processes with Artificial Intelligence</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analyzing production data to increase production line efficiency</li>
                                <li>Implementing machine learning models to predict equipment failures and reduce downtime</li>
                                <li>Optimizing energy consumption in production processes</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img17.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img18.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Internet of Things (IoT) for Smart Factories</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Connecting machinery and production equipment for more precise monitoring and control</li>
                                <li>Collecting and analyzing performance data to improve production processes</li>
                                <li>Intelligent monitoring of production lines to reduce waste and increase efficiency</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img18.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Blockchain Solutions for Transparency and Security in the Supply Chain</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Tracking raw material sourcing from various suppliers to ensure quality</li>
                                <li>Creating smart contract systems for supplier management</li>
                                <li>Reducing fraud and increasing transparency in supply and production processes</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img19.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Production Data Management and Analysis</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analyzing performance data to improve production efficiency</li>
                                <li>Implementing management dashboards for real-time production monitoring</li>
                                <li>Using production data for optimization and better decision-making</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img20.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Quality Optimization and Waste Reduction in Production</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Using artificial intelligence to predict potential product defects</li>
                                <li>Implementing automated quality control systems on production lines</li>
                                <li>Analyzing production data to reduce waste and enhance quality standards</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/production.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Supply Chain and Logistics Management Systems</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Optimizing procurement and warehousing processes to reduce costs</li>
                                <li>Implementing smart systems for order and distribution management</li>
                                <li>Enhancing communication between manufacturers and suppliers with digital solutions</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Digitalization and Industrial Transformation</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Implementing Industry 4.0 projects for smart manufacturing</li>
                                <li>Deploying integrated software solutions for Manufacturing Execution Systems (MES) and Enterprise Resource Planning (ERP)</li>
                                <li>Training production teams for optimal use of modern technologies</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/digital.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">Results and Value Creation for Manufacturers</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Reducing Production Costs and Increasing Productivity</strong> through Optimization of Manufacturing Processes
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/production.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Improving Product Quality and Reducing Waste</strong> through Data-Driven Approaches and Machine Learning
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhancing Transparency and Security in the Supply Chain</strong> through Blockchain Solutions
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increasing Transparency and Security in the Supply Chain</strong> through Blockchain Solutions
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img2.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Intelligent Management of Resources and Equipment</strong> leveraging the Internet of Things (IoT)
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/fast.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Faster Managerial Decision-Making</strong> using data-driven dashboards
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Optimizing Energy Consumption and Reducing Environmental Costs</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>FAQ</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-start">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>How can I use your services to optimize production?</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-start" style="line-height: 35px !important;">
                        You can contact our consulting team, and after assessing your needs, we will provide the best technology solutions to increase productivity and reduce costs.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>Are these services suitable for all types of manufacturers?</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, we customize our services for various manufacturing industries, including automotive, food production, industrial parts manufacturing, and more.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>How can I improve the quality of my manufactured products?</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        We provide solutions using artificial intelligence, the Internet of Things, and data analytics to predict defects, control quality, and reduce waste.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>Are your systems compatible for integration with existing production management software?</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                       Yes, we design our solutions to seamlessly integrate with your ERP, MES, and other industrial software systems.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>Is training for staff provided for the implementation of these technologies?</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, in addition to implementing the technologies, we also provide necessary training to production teams so they can make the best use of the new tools.
                        <br>
                        We stand alongside manufacturers to transform the production industry through innovative solutions and advanced technologies. For consultation and more information, please contact us.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
  direction: ltr;
}
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  right: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  right: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>